import { render, staticRenderFns } from "./CartStatus.vue?vue&type=template&id=08130532&scoped=true&"
import script from "./CartStatus.vue?vue&type=script&lang=js&"
export * from "./CartStatus.vue?vue&type=script&lang=js&"
import style0 from "./CartStatus.vue?vue&type=style&index=0&id=08130532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08130532",
  null
  
)

export default component.exports